module.exports = __webpack_public_path__ + "img/rollbg.a0f246e8.png";